<i18n>
{
  "de": {
    "loadingPosts": "Lade Beiträge...",
    "noPosts": "Bisher noch keinen Beitrag, besuche diese Seite später nochmal",
    "loadMore": "Mehr laden..."
  },
  "en": {
    "loadingPosts": "Loading posts...",
    "noPosts": "No post here yet. Please visit us later again.",
    "loadMore": "Load more..."
  }
}
</i18n>

<template>
  <section class="section mt-20">
    <div class="container">
      <div class="columns">
        <div
          class="column side-container"
          :class="isMobileView ? 'is-hidden' : 'is-one-quarter'"
        >
          <sidenav />
        </div>
        <div class="column is-three-quarter">
          <div class="filter-controls">
            <div class="mobile-filter-posts">
              <portal-target
                name="mobileFilterPosts"
                slim
              />
            </div>
          </div>

          <div
            v-if="!profilePostsLoaded"
            class="box"
          >
            {{ $t('loadingPosts') }}
          </div>
          <div
            v-else-if="!sortedStickyPosts.length && !segmentedPosts.length"
            class="box"
          >
            {{ $t('noPosts') }}
          </div>

          <div v-show="profilePostsLoaded">
            <profile-post
              v-for="(post, index) in sortedStickyPosts"
              :key="post._id"
              :user="artist"
              :post="post"
              :index="index"
              :sticky="true"
            />

            <profile-post
              v-for="(post, index) in segmentedPosts"
              :key="post._id"
              :user="artist"
              :post="post"
              :index="index"
            />

            <button
              v-if="postIndex < postCount"
              id="load-more-button"
              class="button is-primary is-outlined is-fullwidth"
              @click="loadMore"
            >
              <span id="load-more-text">{{ $t('loadMore') }}</span>
              <div id="spinner-container">
                <hollow-dots-spinner
                  v-show="postsLoading"
                  id="hollow-dots"
                  :animation-duration="1000"
                  :dot-size="10"
                  :dots-num="3"
                  color="#fb3e52"
                />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import sidenav from '~/components/sidenav'
import profilePost from '~/components/profile-post'
import { HollowDotsSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js'

export default {
  components: {
    profilePost,
    sidenav,
    HollowDotsSpinner
  },

  data() {
    return {
      postInterval: 5,
      currentSegment: 1,
      postsLoading: false
    }
  },

  head() {
    return {
      title: this.artist.nickname,
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex, follow' }
      ]
    }
  },

  computed: {
    ...mapState(['artist', 'postFilter', 'profilePostsLoaded']),
    postCount() {
      return this.filteredPosts.length
    },
    postIndex() {
      let index = this.postInterval * this.currentSegment
      if (index > this.postCount) {
        index = this.postCount
      }
      return index
    },
    filteredPosts() {
      if (!this.artist || !this.artist.posts) return []
      return this.filterPosts(this.postFilter, this.artist.posts)
    },
    filteredStickyPosts() {
      if (!this.artist || !this.artist.stickyPosts) return []
      return this.filterPosts(this.postFilter, this.artist.stickyPosts)
    },
    segmentedPosts() {
      return this.filteredPosts.slice(0, this.postIndex)
    },
    sortedStickyPosts() {
      if (
        !this.filteredStickyPosts ||
        !this.filteredStickyPosts.length) {
        return []
      }
      if (!this.filteredStickyPosts[0].stickyOrder) return this.filteredStickyPosts
      return this.filteredStickyPosts.slice().sort((a, b) => {
        if (a.stickyOrder === b.stickyOrder) return 0
        return a.stickyOrder > b.stickyOrder ? 1 : -1
      })
    }
  },

  methods: {
    async loadMore() {
      if (!this.profilePostsLoaded) {
        this.postsLoading = true
        await this.loadAllPosts({
          urlAlias: this.artist.urlAlias
        })
        this.postsLoading = false
      }
      this.currentSegment += 1
    },
    async setTag(tag, byEvent = false) {
      const data = await this.apiGet(`/api/public/${this.artist.urlAlias}/tag/posts/${tag}`)
      if (data) {
        data.id = data._id
        delete data._id
        this.$store.commit('updateTagFilter', [data])
        this.$root.$emit('tagfilter', data)
      }
    },

    ...mapActions(['loadAllPosts'])
  },

  mounted() {
    if (this.$route.params.scrollTo && this.$route.params.scrollTo.target) {
      this.$scrollTo(
        document.querySelector(`#${this.$route.params.scrollTo.target}`)
      )
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.setTag(to.params.tag))
  },

  async beforeRouteUpdate(to, from, next) {
    await this.setTag(to.params.tag, true)
    next()
    // next(vm => vm.setTag(to.params.tag))
  }
}
</script>
<style lang="scss">
@import "assets/sass/_variables";
@import 'epic-spinners/dist/lib/epic-spinners.min.css';

.unscrollable {
  overflow-y: hidden;
  max-height: 100vh;
}

.filter-controls {

  display: flex;
  width: 100%;
  justify-content: flex-end;

  .mobile-filter-posts {
    padding-left: 20px;
    width: 100%;

    .multi-select-filter {
      display: flex;
      flex-direction: row;
      margin-bottom: 15px;
    }
  }
}

#load-more-button {
  height: 3em;

  &:hover {
    #hollow-dots {
      .dot {
        border-color: #ffffff !important;
      }
    }
  }

  #load-more-text {
    margin-left: 55px;
  }

  #spinner-container {
    max-width: 35px;
    width: 35px;
    margin-left: 10px;
  }
}
</style>
